// Instruments the admin can log a trade against, grouped for the pair picker
const TRADE_PAIRS = [
  {
    group: 'Forex',
    pairs: [
      ['EUR/USD', 'EUR/USD'], ['USD/JPY', 'USD/JPY'], ['GBP/USD', 'GBP/USD'], ['USD/CHF', 'USD/CHF'],
      ['AUD/USD', 'AUD/USD'], ['USD/CAD', 'USD/CAD'], ['NZD/USD', 'NZD/USD'],
    ],
  },
  {
    group: 'Indices',
    pairs: [
      ['US30', 'US30 (Dow Jones)'], ['NAS100', 'NAS100 (Nasdaq 100)'], ['SPX500', 'SPX500 (S&P 500)'],
      ['GER40', 'GER40 (DAX 40)'], ['UK100', 'UK100 (FTSE 100)'], ['JPN225', 'JPN225 (Nikkei 225)'],
      ['FRA40', 'FRA40 (CAC 40)'], ['AUS200', 'AUS200 (ASX 200)'], ['HK50', 'HK50 (Hang Seng)'],
      ['EU50', 'EU50 (Euro Stoxx 50)'], ['ES35', 'ES35 (IBEX 35)'], ['SWI20', 'SWI20 (SMI)'],
    ],
  },
  {
    group: 'Commodities',
    pairs: [
      ['XAU/USD', 'Gold (XAU/USD)'], ['XAG/USD', 'Silver (XAG/USD)'], ['WTI/USD', 'Crude Oil (WTI)'],
      ['BRENT/USD', 'Brent Oil'], ['NG/USD', 'Natural Gas'], ['COPPER', 'Copper'], ['CORN', 'Corn'],
      ['WHEAT', 'Wheat'], ['SOYBEAN', 'Soybeans'], ['COFFEE', 'Coffee'],
    ],
  },
  {
    group: 'Bonds',
    pairs: [
      ['US10Y', 'US 10Y Treasury'], ['US30Y', 'US 30Y Treasury'], ['US5Y', 'US 5Y Treasury'],
      ['GER10Y', 'Germany 10Y Bund'], ['UK10Y', 'UK 10Y Gilt'], ['JP10Y', 'Japan 10Y Bond'],
    ],
  },
  {
    group: 'Options',
    pairs: [
      ['SPX_OPT', 'S&P 500 Options'], ['NDX_OPT', 'Nasdaq 100 Options'], ['DJI_OPT', 'Dow Jones Options'],
      ['AAPL_OPT', 'Apple Options'], ['TSLA_OPT', 'Tesla Options'], ['BTC_OPT', 'Bitcoin Options'],
    ],
  },
  {
    group: 'Crypto',
    pairs: [
      ['BTC/USD', 'BTC/USD'], ['ETH/USD', 'ETH/USD'], ['XRP/USD', 'XRP/USD'], ['SOL/USD', 'SOL/USD'],
      ['DOGE/USD', 'DOGE/USD'], ['ADA/USD', 'ADA/USD'], ['LTC/USD', 'LTC/USD'], ['BNB/USD', 'BNB/USD'],
      ['AVAX/USD', 'AVAX/USD'], ['TRX/USD', 'TRX/USD'], ['DOT/USD', 'DOT/USD'], ['SHIB/USD', 'SHIB/USD'],
      ['MATIC/USD', 'MATIC/USD'],
    ],
  },
  {
    group: 'Stocks',
    pairs: [
      ['AAPL', 'AAPL (Apple)'], ['GOOGL', 'GOOGL (Google)'], ['MSFT', 'MSFT (Microsoft)'], ['AMZN', 'AMZN (Amazon)'],
      ['META', 'META (Meta)'], ['TSLA', 'TSLA (Tesla)'], ['NVDA', 'NVDA (NVIDIA)'], ['NFLX', 'NFLX (Netflix)'],
      ['AMD', 'AMD'], ['INTC', 'INTC'], ['BA', 'BA (Boeing)'], ['JPM', 'JPM (JP Morgan)'], ['V', 'V (Visa)'],
      ['MA', 'MA (Mastercard)'], ['XOM', 'XOM (Exxon Mobil)'], ['CVX', 'CVX (Chevron)'], ['BABA', 'BABA (Alibaba)'],
      ['UBER', 'UBER'], ['DIS', 'DIS (Disney)'], ['KO', 'KO (Coca-Cola)'], ['NKE', 'NKE (Nike)'], ['MOVE', 'MOVE'],
      ['REVB', 'REVB'], ['DRCT', 'DRCT'], ['IOTR', 'IOTR'], ['HCTI', 'HCTI'], ['NAMM', 'NAMM'], ['ASTI', 'ASTI'],
      ['IOBT', 'IOBT'], ['ASML', 'ASML (ASML Holding)'], ['LLY', 'LLY (Eli Lilly)'], ['AVGO', 'AVGO (Broadcom)'],
      ['NVO', 'NVO (Novo Nordisk)'], ['TSM', 'TSM (Taiwan Semiconductor)'], ['COST', 'COST (Costco)'],
      ['PEP', 'PEP (PepsiCo)'], ['MCD', "MCD (McDonald's)"], ['WMT', 'WMT (Walmart)'], ['CRM', 'CRM (Salesforce)'],
    ],
  },
]

export default TRADE_PAIRS
